import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M6.5,10h-3A1.5,1.5,0,0,1,2,8.5v-3A1.5,1.5,0,0,1,3.5,4h3A1.5,1.5,0,0,1,8,5.5v3A1.5,1.5,0,0,1,6.5,10ZM4,8H6V6H4Z"/><path d="M6.5,19h-3A1.5,1.5,0,0,1,2,17.5v-3A1.5,1.5,0,0,1,3.5,13h3A1.5,1.5,0,0,1,8,14.5v3A1.5,1.5,0,0,1,6.5,19ZM4,17H6V15H4Z"/><path d="M6.5,28h-3A1.5,1.5,0,0,1,2,26.5v-3A1.5,1.5,0,0,1,3.5,22h3A1.5,1.5,0,0,1,8,23.5v3A1.5,1.5,0,0,1,6.5,28ZM4,26H6V24H4Z"/><path d="M29,8H12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29a1,1,0,0,1,1,1h0A1,1,0,0,1,29,8Z"/><path d="M29,17H12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29a1,1,0,0,1,1,1h0A1,1,0,0,1,29,17Z"/><path d="M29,26H12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29a1,1,0,0,1,1,1h0A1,1,0,0,1,29,26Z"/>';
export var ListOutlineSVG = function ListOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ListOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ListOutlineSVG);